import React, { Component } from "react";

import Moment from "moment";
import es from "moment/locale/es";

import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton
} from "react-share";
Moment.locale("es", es);



class CardNews extends Component {

  render() {


    return (
     <div key={this.props.data.id} style={{ marginRight: '20px' }} className="item">
          <div className="card">
            <div className="card-block">
              <div className="card-img">
                <a href={`/es/noticias/${(this.props.data.titulo).replace(/[^-A-Za-z0-9]+/g, '-').toLowerCase()}`} title="">
                  <img

                    src={this.props.data.imagen[0].url} alt={this.props.data.imagen[0].url} className="card-img-top" />
                </a>
                <div className="card-fecha">
                  <p>  {Moment(this.props.data.fecha).format(
                    "D"
                  )}</p>
                  <p>  {Moment(this.props.data.fecha).format(
                    "MMMM"
                  )}  </p>
                </div>
              </div>
              <div className="card-cont">
                <p className="cat">
                  <a href={`/es/category/${this.props.data.Categorys.nombre.replace(/[^-A-Za-z0-9]+/g, '-').toLowerCase()}`}>{this.props.data.Categorys.nombre}</a>                    </p>
                <h3 className="card-title">
                  <a href={`/es/noticias/${(this.props.data.titulo).replace(/[^-A-Za-z0-9]+/g, '-').toLowerCase()}`} >
                    {this.props.data.titulo}                     </a>
                </h3>
                <div className="parrafo-body">
                  {this.props.data.min_descripcion}
                </div>
                <p className="a-none">
                  <a style={{ marginTop: '15px', }} href={`/es/noticias/${(this.props.data.titulo).replace(/[^-A-Za-z0-9]+/g, '-').toLowerCase()}`} className="btn btn-secondary">
                    <i className="fa fa-long-arrow-right"  ></i> Seguir leyendo                        </a>
                </p>
                <p style={{display:'flex'}}>

                  <FacebookShareButton
                     
                    url={this.props.props.location.host + "/es/noticias/" + (this.props.data.titulo).replace(/[^-A-Za-z0-9]+/g, '-').toLowerCase()}
                  >
                    <div className='redes fac' >
                      <i className="fa fa-facebook"  ></i>
                    </div>
                  </FacebookShareButton>



                  <TwitterShareButton
                    title={this.props.data.titulo}
                    url={this.props.props.location.host + "/es/noticias/" + (this.props.data.titulo).replace(/[^-A-Za-z0-9]+/g, '-').toLowerCase()}
                  >
                    <div className='redes twi' >
                      <i className="fa fa-twitter"  ></i>
                    </div>
                  </TwitterShareButton>



                  <LinkedinShareButton className='redes lin'
                    title={this.props.data.titulo}
                    summary={this.props.data.min_descripcion}
                    url={this.props.props.location.host + "/es/noticias/" + (this.props.data.titulo).replace(/[^-A-Za-z0-9]+/g, '-').toLowerCase()}
                  >
                    <div className='redes lin' >
                      <i className="fa fa-linkedin"  ></i>
                    </div>
                  </LinkedinShareButton>

                </p>
              </div>
            </div>
          </div>
        </div>
    )
  }
}

export default CardNews
